<template>
  <div>
    <div :class="[(conEstilosClaros) ? 'form-group color-claro' : 'form-group']" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" class="form-control" v-model="idDelModelo" @change="cambiarDatos($event)">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un tipo de página</option>
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todas.Nombre}} los tipos de páginas</option>
        <option v-for="(pagina,index) in paginas" :value="pagina.PaginaDeIntranetId" :key="index">{{pagina.Titulo}}</option>
      </select>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import axios from 'axios';
  import api from '@/../static/js/api';
  import comun from '@/../static/js/comun';

  export default {
    data() {
      return {
        enumeraciones,
        comun,
        paginas: [],
        idDelModelo: null
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      idDelInput: String,
      valorDefinido: Number,
      parametros: Object,
      conEstilosClaros: {
          type: Boolean,
          default: false
      },
    },
    mounted() {
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }

      this.$store.dispatch("A_SICPO_Catalogos_establecer029PaginasDeIntranet", parametros);
    },
    methods: {
      cargaPaginasDeIntranet: function() {
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {}
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba;

        let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);

        axios.post(api.conexion + api.SICPO.catalogos.C029PaginasDeIntranet, this.parametros, headerPeticion)
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              this.paginas = respuesta.data.PaginasDeIntranet;
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
          })
      },
      cambiarDatos(evento) {
        this.idDelModelo = evento.target.value;
        const parametros = {
          llave: this.idDelInput,
          valor: evento.target.value
        }
        let obtenerTipoPaginaObj = this.obtenerTipoPaginaObj(evento.target.value);
        this.$store.dispatch("A_SICPO_Catalogos_establecer029PaginasDeIntranet", parametros);
        this.$emit("valorParaElPadre", evento,obtenerTipoPaginaObj);
      },
      obtenerTipoPaginaObj: function(paginaId) {
        let id = parseInt(paginaId);
        let pagina = this.paginas.find(pBD => pBD.PaginaDeIntranetId == id);
        return pagina;
      }
    },
    created() {
      this.cargaPaginasDeIntranet();
    }
  }
</script>
<style scoped>
.color-claro select {
  background-color: rgb(185, 185, 185);
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/SICPO/Catalogos/C029PaginasDeIntranet.vue